import styled from "styled-components";

export const FormFieldContainer = styled.div`
  margin-top: 0.825em;
  margin-bottom: 0.825em;
  width: 100%;
`;

export const FormCenteredContainer = styled.div`
  align-items: center;
  margin-top: 0.825em;
  margin-bottom: 0.825em;
`;

export const FormValidationError = styled.span`
  color: ${(props) => props.theme.colors.accent1};
  font-weight: 500;
`;
